/*@flow*/
import client from 'store/apollo';
import gql from 'graphql-tag';
import type { DocumentNode } from 'graphql';
import GetAlertSubscriptions from '../queries/GetAlertSubscriptions';
import type { CreateAlertSubscription_createAlertSubscription } from './__generated__/CreateAlertSubscription';

export default {
  commit: (props: {
    districtId: ID,
    alertName: string,
  }): Promise<?CreateAlertSubscription_createAlertSubscription> =>
    client
      .mutate({
        mutation: gql`
          mutation CreateAlertSubscription(
            $alertName: String!
            $districtId: ID!
          ) {
            createAlertSubscription(
              input: { alertName: $alertName, districtId: $districtId }
            ) {
              success
              errors
            }
          }
        `,
        variables: props,
        // see: https://github.com/apollographql/apollo-client/blob/master/docs/source/basics/mutations.md#optionsrefetchqueries
        refetchQueries: [
          {
            query: GetAlertSubscriptions,
            variables: { districtId: props.districtId },
          },
        ],
      })
      .then(res => res.data && res.data.createAlertSubscription),
};
